import { useCallback, useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

// Corbeille contrats (30 j) — partagée : Inscrire › Contrats et Paiements Membres › Regrouper
export function ContractsTrashPanel({ onRestored, light = false }) {
  const [data, setData] = useState(null);
  const [busy, setBusy] = useState(null);
  const load = useCallback(() => api.get("/student-contracts/trash/list").then((r) => setData(r.data)).catch(() => setData({ items: [], older_archived: 0 })), []);
  useEffect(() => { load(); }, [load]);
  const restore = async (c) => {
    setBusy(c.id);
    try {
      const { data: r } = await api.post(`/student-contracts/${c.id}/restore`);
      toast.success(`${r.full_name} restauré (statut ${r.statut})${r.portal_unblocked ? " · accès portail rétabli" : ""}`);
      load(); onRestored?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Restauration impossible"); }
    setBusy(null);
  };
  const days = (c) => Math.max(0, Math.ceil((new Date(c.expires_at) - Date.now()) / 86400000));
  const box = light ? "border-zinc-300 bg-white text-zinc-800" : "border-zinc-800 bg-zinc-900/40 text-zinc-300";
  const muted = light ? "text-zinc-500" : "text-zinc-500";
  return (
    <details className={`rounded-xl border p-3 text-sm ${box}`} data-testid="contracts-trash-panel">
      <summary className="cursor-pointer font-bold flex items-center gap-2">🗑 Corbeille contrats {data && <span className={`font-normal ${muted}`}>({data.items.length}) · restaurables pendant 30 jours</span>}</summary>
      <p className={`text-xs mt-2 ${muted}`}>Contrats archivés depuis Contrats Élèves (Supprimer), Regrouper (🗑 contrat) ou le Carnet (compte élève). Après 30 jours ils restent archivés (historique conservé) mais ne sont plus listés ici{data?.older_archived ? ` — ${data.older_archived} archivé(s) plus ancien(s) visibles via le filtre « Archivé »` : ""}.</p>
      {data && data.items.length === 0 && <p className={`text-xs mt-2 ${muted}`} data-testid="contracts-trash-empty">La corbeille est vide.</p>}
      <ul className="mt-2 space-y-1">
        {data?.items.map((c) => (
          <li key={c.id} className={`flex items-center justify-between gap-2 rounded border px-2 py-1.5 ${light ? "border-zinc-200" : "border-zinc-800"}`} data-testid={`contracts-trash-item-${c.id}`}>
            <div className="min-w-0">
              <div className="font-semibold truncate">{c.full_name} <span className={`font-normal ${muted}`}>· {c.discipline || "—"} · {c.email || c.parent_email || "—"}</span></div>
              <div className={`text-[11px] ${muted}`}>{c.archived_reason || "Archivé"} · le {String(c.archived_at).slice(0, 10)} · <span className={days(c) <= 5 ? "text-rose-500" : ""}>fin de la corbeille dans {days(c)} j</span></div>
            </div>
            <button onClick={() => restore(c)} disabled={busy === c.id} className="shrink-0 px-3 py-1.5 rounded-lg bg-emerald-700 hover:bg-emerald-600 disabled:opacity-50 text-white text-xs font-bold" data-testid={`contracts-trash-restore-${c.id}`}>{busy === c.id ? "…" : "↩ Restaurer"}</button>
          </li>
        ))}
      </ul>
    </details>
  );
}
